module.exports = __webpack_public_path__ + "static/media/fa-solid-900.0ea4a902.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fontawesome/webfonts/fa-solid-900.ttf
// module id = 883
// module chunks = 0